interface Properties {
  width?: number;
  height?: number;
  color?: string;
}

/**
 * Exact "01 align center" (3-dot menu) asset from the PAGES tab Figma component.
 * Figma renders this rotated 90deg so the 3 dots read vertically ("more options").
 */
const FigmaMenuDotsIcon = ({ width = 16, height = 16, color = '#8B5CF6' }: Properties) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 16.0008 2.6667'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={{ transform: 'rotate(90deg)' }}
    >
      <path
        d='M1.33333 2.66667C2.06971 2.66667 2.66667 2.06971 2.66667 1.33333C2.66667 0.596954 2.06971 0 1.33333 0C0.596954 0 0 0.596954 0 1.33333C0 2.06971 0.596954 2.66667 1.33333 2.66667Z'
        fill={color}
      />
      <path
        d='M7.99996 2.66667C8.73634 2.66667 9.33329 2.06972 9.33329 1.33334C9.33329 0.596957 8.73634 3.65577e-06 7.99996 3.65577e-06C7.26358 3.65577e-06 6.66663 0.596957 6.66663 1.33334C6.66663 2.06972 7.26358 2.66667 7.99996 2.66667Z'
        fill={color}
      />
      <path
        d='M14.6675 2.66667C15.4038 2.66667 16.0008 2.06972 16.0008 1.33334C16.0008 0.596957 15.4038 3.65577e-06 14.6675 3.65577e-06C13.9311 3.65577e-06 13.3341 0.596957 13.3341 1.33334C13.3341 2.06972 13.9311 2.66667 14.6675 2.66667Z'
        fill={color}
      />
    </svg>
  );
};

export default FigmaMenuDotsIcon;
